import React from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import moment from 'moment-timezone';
import { DataTable } from 'primereact/datatable';
import { Panel } from 'primereact/panel';
import { Column } from 'primereact/column';
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl';
import UserListHeader from './UserListHeader';

const messages = defineMessages({
  name: { id: 'attrs.name', defaultMessage: 'Name' },
  email: { id: 'attrs.email', defaultMessage: 'Email' },
  role: { id: 'attrs.role', defaultMessage: 'Role' },
  created: { id: 'attrs.created', defaultMessage: 'Created' },
  administrator: { id: 'attrs.role.administrator', defaultMessage: 'Administrator' },
  owner: { id: 'attrs.role.owner', defaultMessage: 'Owner' },
  externalSupport: { id: 'attrs.role.external-support', defaultMessage: 'External Support' },
  user: { id: 'attrs.role.user', defaultMessage: 'User' },
  status: { id: 'attrs.status', defaultMessage: 'Status' },
  activating: { id: 'attrs.activate_user', defaultMessage: 'Activate User' },
  deactivating: { id: 'attrs.deactivate_user', defaultMessage: 'Deactivate User' },
  notAvailable: { id: 'lbl.not_available', defaultMessage: 'Not Available' },
});

const nameTemplate = (rowData, { currentAccount }) => (
  <Link to={`/accounts/${currentAccount}/users/${rowData.id}`} className="app-link">
    {rowData.name}
  </Link>
);

export const createdTemplate = (rowData, { formatDate }) => {
  const created = formatDate(moment(rowData.createdOn), {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
  });
  return created;
};

const statusTemplate = rowData => (
  (
    <div align="center">
      {rowData.enabled
        ? <FormattedMessage id="lbl.active" defaultMessage="Active" />
        : <FormattedMessage id="lbl.inactive" defaultMessage="Inactive" />
      }

    </div>
  )
);

const UserList = (props) => {
  const {
    connection: { edges },
    intl: { formatMessage, formatDate },
    currentAccount,
    loading,
  } = props;

  const connectionRows = edges.map(({ node, role }) => ({
    ...node,
    name: `${node.firstName} ${node.lastName}`,
    role,
  }));

  const nameHeader = formatMessage(messages.name);
  const emailHeader = formatMessage(messages.email);
  const roleHeader = formatMessage(messages.role);
  const createdHeader = formatMessage(messages.created);
  const statusHeader = formatMessage(messages.status);
  const roleTemplate = (rowData) => {
    const { role } = rowData;
    switch (role) {
      case 'admin':
      case 'nbm-admin':
        return <span>{formatMessage(messages.administrator)}</span>;
      case 'owner':
      case 'nbm-owner':
        return <span>{formatMessage(messages.owner)}</span>;
      case 'external-support':
      case 'nbm-external-support':
        return <span>{formatMessage(messages.externalSupport)}</span>;
      case 'member':
      case 'nbm-member':
        return <span>{formatMessage(messages.user)}</span>;
      default:
        return '';
    }
  };

  return (
    <div className="p-grid">
      <div className="p-col-12">
        <div className="brand-detailed-wrapper">
          <Panel>
            <div className="p-grid">
              <div className="p-col-12">
                <UserListHeader />
              </div>
              <div className="p-col-12 align-center">
                <DataTable
                  value={connectionRows}
                  responsive
                  lazy
                  loading={loading}
                  autoLayout
                >
                  <Column
                    field="name"
                    header={nameHeader}
                    body={nameTemplate}
                    currentAccount={currentAccount}
                    style={{ textAlign: 'left' }}
                  />
                  <Column field="email" header={emailHeader} />
                  <Column
                    field="role"
                    // sortField="role"
                    header={roleHeader}
                    body={roleTemplate}
                  />
                  <Column
                    field="role"
                    // sortField="role"
                    header={statusHeader}
                    body={statusTemplate}
                  />
                  <Column field="createdOn" header={createdHeader} formatDate={formatDate} body={createdTemplate} />
                </DataTable>
              </div>
            </div>
          </Panel>
        </div>
      </div>
    </div>
  );
};

UserList.propTypes = {
  connection: PropTypes.objectOf(PropTypes.any).isRequired,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
    formatDate: PropTypes.func,
  }).isRequired,
  currentAccount: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default withRouter(injectIntl(UserList));
